export default __webpack_public_path__ + "static/media/sports-shoes.47db55e7.webp";